module.exports = __webpack_public_path__ + "img/BecomePan-3.674ab20f.svg";